import React, { Dispatch, SetStateAction, useState } from "react";
import CharactersGroupSelection from "./CharactersGroupSelection";
import PlayersSelection from "./PlayersSelection";
import { IInterestingDiscussionGameConfig } from "../../../../common/types";

interface Props {
    nextToPlay: () => void;
    backToDetails: () => void;
    config: IInterestingDiscussionGameConfig;
    changeConfig: Dispatch<SetStateAction<IInterestingDiscussionGameConfig>>;
}
export enum ConfigStep {
    PLAYERS = "players",
    CHARACTERS = "characters"
}

const InterestingDiscussionGameConfig = ({ nextToPlay, backToDetails, config, changeConfig}: Props) => {
    const [configStep, setConfigStep] = useState(ConfigStep.PLAYERS);

    const toPlayersSelection = () => {
        setConfigStep(ConfigStep.PLAYERS);
    };

    const toCharacterSelection = () => {
        setConfigStep(ConfigStep.CHARACTERS);
    };

    const playersSelection = <PlayersSelection
        config={config}
        changeConfig={changeConfig}
        moveBack={backToDetails}
        moveForward={toCharacterSelection}
        />;

    const charactersGroupSelection = <CharactersGroupSelection
        moveBack={toPlayersSelection}
        moveForward={nextToPlay}
        config={config}
        changeConfig={changeConfig}
        />;

    return  configStep === ConfigStep.PLAYERS ? playersSelection : charactersGroupSelection;
};

export default InterestingDiscussionGameConfig;
